import * as AT from 'constants/actionTypes';

export const getEmoji = () => ({
  type: AT.GET_EMOJI
});
